









export default {
  name: 'epb-progress-bar',
  computed: {
    progressWidth: function (): String {
      if (this.progress < 0) {
        return '0%';
      }
      if (this.progress > 100) {
        return '100%';
      }
      return `${ this.progress }%`;
    }
  },
  props: {
    type: { // regular (static), infinite (never stops)
      type: String,
      default: 'regular'
    },
    color: {
      type: String,
      default: 'primary'
    },
    progress: { // % of colored progress
      type: Number,
      default: 0
    },
    rounded: Boolean
  }
};
